import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { DataCenter } from './pages/DataCenter';
import { Services } from './pages/Services';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { English } from './pages/English';

import { ScrollToTop } from './components/ScrollToTop';
import { useEffect } from 'react';
import { initMatomo } from './components/matomo';


function App() {

  useEffect(() => {
  initMatomo();
}, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/datacenter" element={<DataCenter />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/english" element={<English />} />
      </Routes>
    </Router>
  );
}

export default App;
